import io from "socket.io-client";

export const socket = io("https://devapi.linkhealthstaff.com", {
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 4000,
});
